module.exports = __webpack_public_path__ + "view_manager.bd3c1b9a8bc43daa4242e0e045719ecd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/view_manager.svg
// module id = 346
// module chunks = 0